/**
 * @file: PlanDetailReasonSignature.tsx
 *
 * The unsolved/遗留 reason + customer-signature image row shared by the
 * maintenance-plan remind & updated bodies — both render the same
 * plan-detail snapshot. The reason label and the signature sit on one
 * wrapping row; renders nothing when neither is present.
 */

import { Typography } from '@euler/app/components/typography';
import { Img } from '@euler/components/image/AdvancedImage';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { MaintenanceServicePlanDetailType } from '@euler/model/enum/MaintenanceServicePlanDetailType';
import { FC } from 'react';
import { View } from 'react-native';
import { reasonLabelFor } from './labels';
import { labelColor, valueColor } from './primitives';

export const PlanDetailReasonSignature: FC<{
  type: MaintenanceServicePlanDetailType;
  unsolvedReason?: string;
  signatureImgUrl?: string;
}> = ({ type, unsolvedReason, signatureImgUrl }) => {
  const { rpx } = useResponsiveContext();
  if (!unsolvedReason && !signatureImgUrl) return null;
  return (
    <View
      css={`
        flex-direction: row;
        align-items: center;
        flex-wrap: wrap;
        margin-top: ${rpx(4)}px;
      `}
    >
      {unsolvedReason ? (
        <>
          <Typography.Text
            size={rpx(12)}
            color={labelColor}
            style={{ minWidth: rpx(56) }}
          >
            {reasonLabelFor(type)}
          </Typography.Text>
          <Typography.Text size={rpx(12)} color={valueColor}>
            {unsolvedReason}
          </Typography.Text>
        </>
      ) : null}
      {signatureImgUrl ? (
        <View style={{ marginLeft: unsolvedReason ? rpx(16) : 0 }}>
          <Img
            uri={signatureImgUrl}
            width={rpx(60)}
            height={rpx(24)}
            resizeMode="contain"
          />
        </View>
      ) : null}
    </View>
  );
};
